import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from 'src/app/core/_config/app.config';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { FileService } from 'src/app/services/file.service';
import { mockReceivingBatchCollectors, mockReceivingLineCollectors } from '../objects.spec';

@Injectable({
    providedIn: 'root',
})
export class CollectorFileAuditService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig, private fileService: FileService) {}

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    private batchCollectorsList = new BehaviorSubject(mockReceivingBatchCollectors);
    private lineCollectorsList = new BehaviorSubject(mockReceivingLineCollectors);

    getReceivingLinesSaleOff(id: string, params: any): Observable<any> {
        return this.http.get(`${this.API_URL}ReceivingCollector/Lines/SaleOff`, params);
    }

    countStatus(id: string, params: any) {
        return this.http.get<ResponseCustom>(`${this.API_URL}ReceivingCollector/Lines/CountStatus`, params);
    }

    sendReceivingLineFromProcess(params: any) {
        return this.http.post<ResponseCustom>(`${this.API_URL}ReceivingCollector/Lines/ProcessFile`, params);
    }

    processAll(batchId, params?: any) {
        return this.http.post<ResponseCustom>(
            `${this.API_URL}ReceivingCollector/Lines/Batch/${batchId}/ProcessAll`,
            params,
        );
    }

    RegisteredChargeProcessAll(batchId, limit, params?: any) {
        return this.http.post<ResponseCustom>(
            `${this.API_URL}ReceivingCollector/Lines/Batch/${batchId}/${limit}/RegisteredChargeProcessAll`,
            params,
        );
    }

    sendReceivingLineFromSave(params: any) {
        return this.http.post<ResponseCustom>(`${this.API_URL}ReceivingCollector/Lines/SaveChangeLine`, params);
    }

    accountBatch(batchId, dateSelected: any): Observable<any> {
        return this.http.post(`${this.API_URL}ReceivingCollector/Batch/${batchId}/Account`, {
            dateSelected: dateSelected,
        });
    }

    changeStatuReceivingBatch(id: string, processStatusId: number) {
        return this.http.patch(`${this.API_URL}ReceivingCollector/Batch/${id}/ChangeStatus`, processStatusId);
    }

    getReceivingBatchForId(batchId: string) {
        return this.http.get<ResponseCustom>(`${this.API_URL}ReceivingCollector/Batch/${batchId}`);
    }

    exportReceivingLines(receivingBatchId: string) {
        return this.http
            .get(`${this.API_URL}ReceivingCollector/Lines/ExportReceivingLines/${receivingBatchId}`, {
                responseType: 'arraybuffer',
                observe: 'response',
            })
            .pipe(
                map((httpResponse: HttpResponse<ArrayBuffer>) =>
                    this.fileService.extractFileNameAndBlobService(httpResponse),
                ),
            );
    }

    DeleteDuplicateSaleOff(id: number): Observable<any> {
        return this.http.delete(`${this.API_URL}ReceivingCollector/Lines/DeleteDuplicateSaleOff/${id}`);
    }
}
